// LIBRARIES
import React from 'react';
import PropTypes from 'prop-types';
import config from 'config';
import classNames from 'classnames';
import {translate} from 'react-i18next';
import { OverlayTrigger, Tooltip, Popover, MenuItem} from 'react-bootstrap';
import * as categories from 'components/SharedComponents/categories';

// MODULES
import * as mixpanelTracker from 'app-lib/mixpanel/mixpanelTracker';
import InlineEdit from 'components/SharedComponents/Inline/inline-edit';

// Helpers
import * as recordingHelper from 'app-lib/helpers/recordingHelper';
import { filePickerHelper } from 'app-lib/helpers/filepicker';
import * as navigationHelper from 'app-lib/helpers/navigation-helper';

// Models
import Page from 'src/model/page';

// STRINGS
const classPrefix = 'catalog-card';

export class CatalogCards extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showToolBar: false,
            showProgressCursor: false,
            characterEntered: 0,
            showEditTitleIcon: false,
            editTitleFocus: false,
            errorInTitleMaxLengthExceeded: false,
            errorInTitle: false
        };

        this.recordingCicked = false;
    }

    componentDidMount() {
        this.recordingCicked = true;
    }

    componentWillReceiveProps(nextProps) {
        this.recordingCicked = true;
        this.setState({ showProgressCursor: false});
    }
    clicked() {
        if (this.recordingCicked) {
            const mixpanelAttributes = {
                contentKey: this.props.details.id,
                product: this.props.details.product,
                productRefKey: this.props.details.productRefKey
            };
            mixpanelTracker.track(`${mixpanelTracker.channelPage}-${mixpanelTracker.cardClicked}`, mixpanelAttributes);
            navigationHelper.navigateToWatchNow(this.props.params, this.props.details.id, Page.CHANNEL);
        }
    }

    editTitle(id, title) {
        const mixpanelAttributes = { contentKey: id, category: this.props.details.category };
        mixpanelTracker.track(`${mixpanelTracker.channelPage}-${mixpanelTracker.recordingTitleChanged}`, mixpanelAttributes);
        const body = { title };
        this.props.editRecordingTitle(id, body);
    }

    catalogTitle() {
        if (this.props.isChannelOwner) {
            return (
                <InlineEdit
                  t={this.props.t}
                  editText={this.editTitle.bind(this)}
                  text={this.props.details.title}
                  id={this.props.details.id}
                  stopPropogation={true}
                  characterCheckRequired={true}
                  regex={/\[|\]|\{|\}+/}
                />
          );
        }
        const bioClass = classNames({
            'recording-title-hover': this.state.showToolBar,
            'recording-title': !this.state.showToolBar
        });
        return <span className={bioClass} title={this.props.details.title}>{this.props.details.title}</span>;
    }
    channelTitle() {
        return <div className="recording-channel-title text-left">{this.props.channelTitle}</div>;
    }
    catalogCategory() {
        return <span className="recording-category float-left">{this.props.details.category}</span>;
    }
    catalogDate() {
        const dateString = `${recordingHelper.recordingCreatedDate(this.props.details.createdTime, 'll')} `;
        return <span className="recording-date float-left">{dateString}</span>;
    }

    toggleToolBar(val) {
        this.setState({showToolBar: val});
    }
    chooseThumbnail(index, id, e) {
        const mixpanelAttributes = { contentKey: id };
        mixpanelTracker.track(`${mixpanelTracker.channelPage}-${mixpanelTracker.thumbnailButtonClicked}`, mixpanelAttributes);
        e.stopPropagation();
        const self = this.props;

        const filePickerOptions = {
            fileType: 'thumbnails',
            extension: ['.jpg', '.jpeg', '.png'],
            cropRatio: 16 / 9,
            imageMin: [300, 170],
            customText: config.filepicker.thumbnail.customText,
            customCss: config.filepicker.thumbnail.customCss
        };

        filePickerHelper.pickAndStore(filePickerOptions, (thumbnailUrl, Blobs) => {
            const body = {
                fileName: Blobs[0].filename,
                fileType: Blobs[0].mimetype,
                size: Blobs[0].size,
                location: thumbnailUrl,
                fileWidth: Blobs[0].cropped.cropArea.size[0],
                fileHeight: Blobs[0].cropped.cropArea.size[1]
            };
            mixpanelTracker.track(`${mixpanelTracker.channelPage}-${mixpanelTracker.thumbnailImageUploaded}`, mixpanelAttributes);

            self.thumbnailUploadClicked(id, body);
        });
    }

    backgroundImage(detail) {
        if (detail) {
            if (detail.thumbnail) {
                return {backgroundImage: `url(${detail.thumbnail.cdnLocation})`};
            } else if (detail.defaultThumbnail && detail.defaultThumbnail.exist) {
                return {backgroundImage: `url(${detail.defaultThumbnail.cdnLocation})`};
            }
        }
        return null;
    }

    moreIcon(index, id, isChannelOwner) {
        let element = null;
        if (!isChannelOwner) {
            return element;
        }
        element = (<span className="select-icons show-more" id={`more-${id}`} onClick={this.moreIconClicked.bind(this, id)}><i className="material-icons icon-adjust">more_vert</i></span>);
        return element;
    }
    moreIconClicked(id, e) {
        e.stopPropagation();
        e.currentTarget.classList.toggle('show-less');

        const thumb = document.getElementById(`thumb-${id}`);
        const category = document.getElementById(`category-${id}`);

        // toggle the state
        thumb.classList.remove('slideInRight');
        thumb.classList.add('slideInLeft');
        category.classList.remove('slideInRight');
        category.classList.add('slideInLeft');

        window.setTimeout(() => { this.setState({showToolBar: !this.state.showToolBar}); }, 150);
    }
    generatingThumbnailText() {
        const {t} = this.props;
        const details = this.props.details;
        if (this.props.isChannelOwner && details && !details.thumbnail && details.defaultThumbnail && !details.defaultThumbnail.exist) {
            return (<span className="default-thumbnail-text">{t('CatalogCard.generating-thumbnail-text')}</span>);
        }
        return null;
    }

    thumbnailImageIcon(index, details, isChannelOwner) {
        const {t} = this.props;
        let element = null;
        if (!isChannelOwner) {
            return element;
        }
        const selectClass = classNames({
            hide: !this.state.showToolBar,
            'select-thumbnail animated slideInRight': this.state.showToolBar
        });
        const tooltip = (
            <Tooltip className="thumbnail-icon-tooltip" id="tooltip"><strong>{t('CatalogCard.add-thumbnail')}</strong></Tooltip>
        );
        const tooltipRemove = (
            <Tooltip className="thumbnail-icon-tooltip" id="tooltip"><strong>{t('CatalogCard.remove-thumbnail')}</strong></Tooltip>
        );
        const removeThumbnail = (<OverlayTrigger placement="bottom" overlay={tooltipRemove}>
            <span
              className={`select-icons ${selectClass}`} id={`thumb-${details.id}`} onClick={this.props.deleteThumbnail.bind(this, details.id)}
            >
                <img
                  src={`${config.assets.url}/images/catalog/remove-thumbnail.png`}
                  alt="remove thumbnail"
                  className="thumbnail-icon_remove"
                />
            </span>
        </OverlayTrigger>);

        const addThumbnail = (<OverlayTrigger placement="bottom" overlay={tooltip}>
            <span
              className={`select-icons ${selectClass}`} id={`thumb-${details.id}`} onClick={this.chooseThumbnail.bind(this, index, details.id)}
            >
                <i className="material-icons icon-adjust">photo</i></span>
        </OverlayTrigger>);

        if (details.thumbnail) {
            element = removeThumbnail;
        } else if (details.defaultThumbnail) {
            if (details.defaultThumbnail.exist) {
                element = removeThumbnail;
            } else {
                element = addThumbnail;
            }
        } else {
            element = addThumbnail;
        }

        return element;
    }
    renderCategories(id) {
        const result = [];
        const {t} = this.props;

        categories.categoriesArray.forEach((category) => {
            result.push(
                <li
                  id={`category-${category}`}
                  key={`category-${category}`}
                  className="category-list"
                  onClick={this.categorySelected.bind(this, id, category)}
                >
                    {t(`categories.${category}`)}
                </li>
            );
        });

        return result;
    }
    categorySelected(id, category) {
        const mixpanelAttributes = {
            category,
            contentKey: id
        };
        mixpanelTracker.track(`${mixpanelTracker.channelPage}-${mixpanelTracker.categorySelected}`, mixpanelAttributes);

        this.recordingCicked = false;
        const body = {
            category
        };

        this.setState({showToolBar: false});
        this.closePopover();
        this.props.categoryChangeClicked(id, body);
    }
    categoryIcon(index, id, isChannelOwner) {
        const {t} = this.props;
        let element = null;
        if (!isChannelOwner) {
            return element;
        }
        const selectClass = classNames({
            hide: !this.state.showToolBar,
            'select-category animated slideInRight': this.state.showToolBar
        });
        const popover = (
            <Popover id="">
                <div className="category-dropdown">
                    <MenuItem header>SELECT CATEGORY</MenuItem>
                    <ul>
                    {this.renderCategories(id)}
                    </ul>
                </div>
            </Popover>
        );
        const tooltip = (
            <Tooltip className="thumbnail-icon-tooltip" id="tooltip"><strong>{t('CatalogCard.add-category')}</strong></Tooltip>
        );
        element = (
            <OverlayTrigger trigger={['click']} placement="bottom" overlay={popover} container={this.refs.catalogCardContainer} rootClose>
                <OverlayTrigger placement="bottom" overlay={tooltip}>
                    <span className={`select-icons ${selectClass}`} id={`category-${id}`} onClick={(e) => { e.stopPropagation(); }}><i className="material-icons icon-adjust">list</i></span>
                </OverlayTrigger>
            </OverlayTrigger>);
        return element;
    }

    closePopover() {
        document.getElementsByClassName('popover')[0].style.visibility = 'hidden';
    }
    whichTooltip() {
        const {t} = this.props;
        const tooltipFeature = (
            <Tooltip className="thumbnail-icon-tooltip" id="tooltip"><strong>{t('CatalogCard.feature')}</strong></Tooltip>
        );
        const tooltipUnfeature = (
            <Tooltip className="thumbnail-icon-tooltip" id="tooltip"><strong>{t('CatalogCard.unfeature')}</strong></Tooltip>
        );
        if (this.props.isFeatured) {
            return tooltipUnfeature;
        }
        return tooltipFeature;
    }
    favoriteIcon(index, id, isChannelOwner, category, featureDisable) {
        let element = null;
        if (!isChannelOwner) {
            return element;
        }
        const selectClass = classNames({
            'is-active': this.props.isFeatured,
            'progress-cursor': this.state.showProgressCursor,
            disabled: featureDisable
        });
        const disabled = featureDisable;
        element = (<OverlayTrigger placement="bottom" overlay={this.whichTooltip()}>
            <button
              className={`select-icons select-favorite ${selectClass}`} id={`favorite-${id}`}
              onClick={this.favoriteIconClicked.bind(this, id, category)}
              disabled={disabled}
            >
                <i className="material-icons icon-adjust">star</i></button>
        </OverlayTrigger>);
        return element;
    }
    favoriteIconClicked(id, category, e) {
        e.stopPropagation();
        this.setState({ showProgressCursor: true});
        const body = !this.props.isFeatured;
        const mixpanelAttributes = {
            category,
            contentKey: id,
            featured: body
        };
        mixpanelTracker.track(`${mixpanelTracker.channelPage}-${mixpanelTracker.featuredClicked}`, mixpanelAttributes);
        this.props.featuredClicked(id, body);
    }
    render() {
        return (
            <figure
              id={`${classPrefix}`}
              className={`${classPrefix} animated pulse`}
              onClick={this.clicked.bind(this)}
            >
                <div
                  ref="catalogCardContainer"
                  id={`${classPrefix}-container-id-${this.props.index}`}
                  className={`${classPrefix}-container`}
                  style={this.backgroundImage(this.props.details)}
                >
                    <i className="material-icons play-circle">play_circle_filled</i>
                    <span className="black-circle"></span>
                    {this.generatingThumbnailText()}
                    {this.moreIcon(this.props.index, this.props.details.id, this.props.isChannelOwner)}
                    {this.thumbnailImageIcon(this.props.index, this.props.details, this.props.isChannelOwner)}
                    {this.categoryIcon(this.props.index, this.props.details.id, this.props.isChannelOwner)}
                    {this.favoriteIcon(this.props.index, this.props.details.id, this.props.isChannelOwner, this.props.details.category, this.props.featureDisable)}
                </div>

                <figcaption className={`${classPrefix}-bio`} >
                    {this.catalogTitle()}
                    <div className="recording-info--container">
                        {this.catalogDate()}
                    </div>
                </figcaption>

            </figure>
        );
    }
}

CatalogCards.propTypes = {
    details: PropTypes.object.isRequired,
    index: PropTypes.string,
    t: PropTypes.func.isRequired,
    createThumbnail: PropTypes.func,
    editRecordingTitle: PropTypes.func,
    channelTitle: PropTypes.string,
    isChannelOwner: PropTypes.bool,
    isFeatured: PropTypes.bool,
    thumbnailUploadClicked: PropTypes.func,
    deleteThumbnail: PropTypes.func,
    categoryChangeClicked: PropTypes.func,
    featuredClicked: PropTypes.func,
    featureDisable: PropTypes.bool,
    params: PropTypes.string
};
export default translate(['translation'])(CatalogCards);



// WEBPACK FOOTER //
// ./src/components/catalog/cards/catalogCards.js